import {IFlash} from "~/interfaces/flashInterfaces";
import {FlashMode} from "~/helpers/flashHelper";

export default function (initialFlash: IFlash = {}) {
  return {
    namespaced: true,
    state: {
      flash: <IFlash>initialFlash,
      trigger: true,
      mode: FlashMode.Banner,
      flashDetails: {},
    },
    mutations: {
      set(state, {flash, mode = FlashMode.Banner, flashDetails = {}}: {flash: IFlash, mode: FlashMode, flashDetails}) {
        state.flash = flash;
        state.trigger = true;
        state.mode = mode;
        state.flashDetails = flashDetails;
      },
      reset(state) {
        state.flash = {};
        state.trigger = false;
      },
      close(state) {
        state.flash = {};
        state.trigger = true;
        state.mode = FlashMode.Banner;
        state.flashDetails = {};
      }
    },
    actions: {}
  };
}